export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -21.0e2ab9fb.png";